module.exports = __webpack_public_path__ + "img/logo.648df510.svg";